function showTrialText(text, minTrialAllImagesTop, shouldOverwrite)
{
  text = replaceVariables(text, undefined, undefined, undefined, 1);

  displayText("trialText",text, shouldOverwrite);//show trial text if any

  showTrialText.prevValue = text;

  if (listStimType[trialRow]==1 || listStimType[trialRow]==4 || listStimType[trialRow]==5)
  {
    spaceTestText = spaceImagesText;
  }
  else
  {
    spaceTestText = spaceWordsText;
  }

  var centerTop = ($('#displayScreen').height()-$('#trialText').height())/2;
  var trialTextPos = new Array();
  trialTextPos = listArrays[allColumns.indexOf('trialTextPos')][trialRow].split('_').filter(function(c) {return c.length != 0});

  setResponseTopPosition();
  if (trialTextPos.length==2)
  {
    currentTextTop = centerTop + adjuster*Number(trialTextPos[0]);
    trialTextContainer.style.top = currentTextTop + 'px';
    // trialTextContainer.style.left = trialTextPos[1] + 'px';
  }
  else if (!isNaN(Number(trialTextPos[0])))
  {
    currentTextTop = centerTop + adjuster*Number(trialTextPos[0]);
    trialTextContainer.style.top = currentTextTop + 'px';
  }
  else if (trialTextPos[0]=="below")
  {
    currentTextTop = bottomTest + spaceTestText;
    trialTextContainer.style.top = currentTextTop + 'px';
  }
  else if (trialTextPos[0]=="center" || minImagesTop === Number.POSITIVE_INFINITY)
  {
    trialTextContainer.style.top = centerTop + 'px';
  }
  else //not specified (na) or 'above'
  {
    //consider minTrialAllImagesTop with priority
    topTest = (window.minTrialAllImagesTop !== undefined && window.minTrialAllImagesTop > 0) ? window.minTrialAllImagesTop : minImagesTop;

    if (listArrays[allColumns.indexOf('test')][trialRow]=="CFPT")
    {
      topTest = parseInt(document.getElementById("CFPT").style.top,10) + 10;
    }

    trialTextHeight = $('#trialText').height();//get height of text
    if (listStimType[trialRow]==4) {
      var videoTop = parseInt(document.getElementById('video1').style.top);
      if (videoTop && videoTop < topTest) {
        topTest = videoTop;
      }
    }

    if (topTest === 0 && isTrialOfType(trialRow, 'audio')) {
      topTest = halfCanvasHeight;
    }
    
    currentTextTop = topTest - spaceTestText - trialTextHeight;//need to tie in spaceTestText and 24 at some point
    trialTextContainer.style.top = currentTextTop + "px";
  }
}